import * as cssClasses from "../constants/cssClasses";

export const getDiscountCssClass = (isDefaultDiscount) =>
	isDefaultDiscount
		? cssClasses.DEFAULT_DISCOUNT_LINE
		: cssClasses.DISCOUNT_LINE;
